import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CardActions } from '@modules/card/interfaces/card-actions.interface';

@Component({
  selector: 'app-card-actions',
  templateUrl: './card-actions.component.html',
  styleUrls: ['./card-actions.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class CardActionsComponent {
  @Input() actions: CardActions[] | null = null;
}
